'use strict';/* global define */define('modules/core/modules/app/services/state-watcher/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["$q", "$resource"];
function factory($q,$resource){// jshint validthis:true
// jshint latedef:false
/**
    * Constructor function for a StateWatcher
    *
    * @param {Object} currentState - current state
    */function StateWatcher(currentState){this.currentState=currentState;}/**
    * Execute a function in case the current state did not change
    *
    * Prevent callback from being called having dependencies
    * on the "old current" state
    *
    * @param  {Object}   currentState - current state
    *
    * @return {Boolean}               - did the state change
    */StateWatcher.prototype.isTheSame=function(currentState){return this.currentState.name===currentState.name;};return{init:init};// ---
/**
     * Initialize a new StateWatcher object
     *
     * @param  {Object} currentState - current state
     * @return {Object}              - initialized statewatcher
     */function init(currentState){return new StateWatcher(currentState);}}module.exports=factory;});
